export enum ToggleType {
  WorkingHours = 'workingHours',
  EmergencyTime = 'emergencyTime',
}
  